function checkForTooltips() {
    const tooltips = document.querySelectorAll('.sk-tooltip-container');
    for( let tooltip of tooltips ) {
        tooltip.addEventListener("click", ( event )=> { 
            event.preventDefault();
           
        });
    }
};

export { checkForTooltips };